// This route exists for URL/bookmark purposes only.
// The AppShell in layout.tsx handles all content rendering client-side.
export default function DashboardRoute() {
  return null;
}
